





































































import { Component, Vue, Prop } from "vue-property-decorator";
import * as _ from "lodash";
import Gailan from "./shijuangailan.vue";
import { CheckMoniResult$ } from "@/request/shezhenjiaoxue";
import Danxuan from "./danxuan.vue";
import Duoxuan from "./duoxuan.vue";
import moment from "moment";
@Component({
  components: {
    Gailan,
    Danxuan,
    Duoxuan,
  },
})
export default class SzsxMoniResult extends Vue {
  private exam: any = {};
  private userId: any = "";
  private filters: any = {
    current_page: 1,
    total_count: 0,
    total_page: 0,
    page_count: 20,
  };
  private result: any = {
    questions: [],
  };
  private get currentQuestions() {
    const startIndex =
      (this.filters.current_page - 1) * this.filters.page_count;
    const tempArr = _.cloneDeep(this.result.questions);
    return tempArr.splice(startIndex, this.filters.page_count);
  }
  /**
   * @description 获得试卷结果详情
   */
  private fetchResultDetail() {
    const params: any = {
      params: {
        moni_id: this.result.moni_id,
      },
    };
    CheckMoniResult$(this, params).then((data: any) => {
      console.log(data);
      data["总分"] = data["总分"];
      data["题目数量"] = data["题目数量"];
      let radioCount = 0;
      let radioScore = 0;
      let multiCount = 0;
      let multiScore = 0;
      let totalCount = 0;
      let totalScore = 0;
      let totalAchieveScore = 0;
      data.questions.forEach((question: any) => {
        if (question["题目类型"] === "单选") {
          radioCount++;
          radioScore += question["分数"];
        }
        if (question["题目类型"] === "多选") {
          multiCount++;
          multiScore += question["分数"];
        }
        if (question["is_answer_right"]) {
          totalAchieveScore += question["分数"];
        }
        totalCount++;
        totalScore += question["分数"];
      });
      data["单选题数量"] = radioCount;
      data["单选题分数"] = radioScore;
      data["多选题数量"] = multiCount;
      data["多选题分数"] = multiScore;
      data["题目数量"] = totalCount;
      data["用时"] = moment(data["结束时间"]).diff(
        moment(data["开始时间"]),
        "minutes"
      );
      data["总分"] = totalScore;
      data["总得分"] = totalAchieveScore;
      this.$set(this, "result", _.cloneDeep(data));
      this.filters.total_count = this.result.questions.length;
      this.filters.total_page = Math.ceil(
        this.result.questions.length / this.filters.page_count
      );
    });
  }

  /**
   * @description 上一页
   */
  private prev() {
    this.filters.current_page--;
  }
  /**
   * @description 下一页
   */
  private next() {
    this.filters.current_page++;
  }
  /**
   * @description 跳转到某题目所在的页面
   */
  private jumpTo(index) {
    const target = Math.ceil((index + 1) / this.filters.page_count);
    if (target === this.filters.current_page) {
      return;
    }
    this.filters.current_page = target;
  }
  /**
   * @description 初始化
   */
  private mounted() {
    if (this.$route.query.id) {
      this.result.moni_id = this.$route.query.id;
      this.fetchResultDetail();
    } else {
      this.$message.error("参数有误，请重新预览");
    }
  }
}
